<template>
  <div
    class="border-solid border-0 border-b border-gray-600 flex flex-row flex-wrap items-center"
    role="row"
    ref="container"
  >
    <div
      v-for="(column, index) in columns"
      :key="index"
      class="flex-1 py-4 lg:block"
      :class="{
        'block': column.onMobile,
        'hidden': !column.onMobile,
        'md:hidden': !column.onTablet,
        'md:block': column.onTablet
      }"
      role="gridcell"
    >
      <div>
        <p
          @click="serviceStatementsAction($event)"
          v-if="row[column.value].text"
          :class="`cursor-pointer block font-light font-sans leading-snug subpixel-antialiased text-base text-black ${column.value}`"
        >
          <span v-html="row[column.value].text"></span>
        </p>
        <p
          v-else
          class="block font-light font-sans leading-snug subpixel-antialiased text-base"
        >
          Not provided
        </p>
      </div>
    </div>
    <div class="flex-1 py-4 lg:block">
      <navigation-context-open
        class="float-right"
        :ariaLabel="`Actions for ${row.service.text}`"
        icon="ellipsis"
        icon-size="large"
        :actions="filteredActions"
        @click="handleRowAction($event)"
      />
    </div>
  </div>
</template>

<script>
import handleRoles from "@/mixins/handleRoles";
import NavigationContextOpen from "@/components/navigation/NavigationContextOpen.vue";

export default {
  name: "DoeRow",
  mixins: [handleRoles],
  props: {
    actions: {
      type: Array,
      required: true
    },
    columns: {
      type: Array
    },
    row: {
      type: Object
    },
    isSelected: {
      type: Boolean,
      required: false
    },
    actionBoxes: {
      type: Boolean
    }
  },
  components: {
    NavigationContextOpen
  },
  methods: {
    serviceStatementsAction($event) {
      this.$set($event, "seNumber", this.row.seNumber.value);
      this.$set($event, "action", "action:statements");
      this.$emit("row:action", $event);
    },
    updateSelectedItems($event) {
      this.$store.commit('SET_BUTTON', this.row.seNumber.value);
      this.$emit("input", $event);
    },
    handleRowAction($event) {
      this.$set($event, "seNumber", this.row.seNumber.value);
      this.$emit("row:action", $event);
    }
  },
  computed: {
    isChecked(){
      let flag=this.$root.selectedItems.includes(this.row.seNumber.value);
      return flag;
    },
    filteredActions() {
      return this.actions.filter(action =>
        action.allowFor.includes(
          this.isServiceDashboardDirector
            ? "admin"
            : "user"
        )
      );
    }
  }
};
</script>

<style lang="scss" scoped>
p {
  max-width: 120px;
}
p.service {
  max-width: 100%;
}
@media (min-width: 768px) {
  p.service {
    max-width: 100%;
  }
}
</style>
